import { IResponse } from "@app/common/types/http";
import { HTTP_ADMISSION, HTTP_MEDICAL } from "@app/config/axios";
import { clearEmptyKeys } from "@app/common/utils/utils";
import type {
  IAccountingNoteElectronicPdfItem,
  IAccountingNotesFilters,
  IAccountingNoteItem,
  IReturnAccountingVoucherParams
} from "./types";
import { isAxiosError } from "axios";
import { warningNotification } from "@app/common/components/notifications";

export async function getAccountingNotesService(filters: IAccountingNotesFilters, token: string) {
  const sanitizedFilters = clearEmptyKeys(filters);
  const res = await HTTP_ADMISSION(token).get<IResponse<IAccountingNoteItem[]>>(
    "/admissions/invoicing-notes",
    { params: sanitizedFilters }
  );
  return res.data;
}

export async function getAccountingNoteElectronicPdfService(invNoteId: number, token: string) {
  try {
    const res = await HTTP_MEDICAL(token).get<IResponse<IAccountingNoteElectronicPdfItem>>(
      `/admissions/invoicing-notes/${invNoteId}/electronic-pdf`
    );

    return res.data;
  } catch (error) {
    if (isAxiosError<IResponse>(error)) {
      warningNotification(error.response?.data?.error);
    } else {
      warningNotification("Error al obtener el PDF electrónico de la nota crédito");
    }

    return null;
  }
}

export async function getReturnAccountingVoucherService(
  params: IReturnAccountingVoucherParams,
  token: string
) {
  const res = await HTTP_ADMISSION(token).get<IResponse<{ base64: string }>>(
    "/admissions/dispensaries/return-accounting-voucher/",
    { params }
  );
  return res.data;
}
